export const otherProjects = [
  {
    title: "Disaster Tweet Classification",
    description:
      "Project which classifies the tweets into the disaster and non-disaster tweets using the Neural Networks builded from scratch .",
    gitLink: "https://github.com/Pranshu321/DisasterTweetML",
    listItems: [
      "Python",
      "NLP",
      "Neural Networks",
      "SVM",
      "Logistic Regression",
      "Google Embeddings",
    ],
    liveLink: "https://github.com/Pranshu321/DisasterTweetML",
  },
  {
    title: "Coding Stats Markdown",
    description:
      "Project which generate the markdown of coding website stats (like leetcode,codeche etc) and can be used for github profile",
    gitLink: "https://github.com/Pranshu321/CodingProfile-mardown-Card",
    liveLink: "https://coding-profile.vercel.app/",
    listItems: ["Next.Js", "MUI", "SVG's", "Typescript"],
  },
  {
    title: "Git Find",
    description:
      "Project that uses the Github API to provide information and insights about a Github user profile. Shows the date the user joined Github, events related to their account, who they follow, information about their repositories, and prominent language in repository.",
    gitLink: "https://github.com/Pranshu321/Git-Find",
    liveLink: "https://gitfind32.netlify.app/",
    listItems: ["React.Js", "Tailwind CSS", "Github API"],
  },
  {
    title: "CryptOne",
    description:
      "CryptOne is a platform that allows you to monitor the cryptocurrency world. With CryptOne, you can view the activity of individual coins, access full information about all cryptocurrencies, see live updates about the current state of the crypto market.",
    gitLink: "https://github.com/Pranshu321/CryptOne",
    liveLink: "https://crypt-one.vercel.app/",
    listItems: ["React.Js", "Rapid API", "Ant Design", "Chart.Js"],
  },
  {
    title: "ThirdPay",
    description:
      "Thirdpay is a payment application that allows users to manage their crypto transactions and transfer funds globally. With its user-friendly interface and powerful features, Thirdpay provides a seamless experience for managing your crypto assets.",
    gitLink: "https://github.com/Pranshu321/shewin",
    liveLink: "https://shewin.vercel.app/",
    listItems: ["Next.js", "Tailwind CSS", "Thirdweb", "Solidity"],
  },
  {
    title: "NIEC Board",
    description:
      "Northern India Engineering College Notices is a project that displays the latest notices from the college using web scraping from the college's main website. The project has an intuitive user interface and a search feature, making it easier for students to find the information they need",
    gitLink: "https://github.com/Pranshu321/health-pilot",
    liveLink: "https://niec.onrender.com/",
    listItems: ["EJS", "CSS", "Web Scraping", "Node.js"],
  },
  {
    title: "JoinFund",
    description:
      "Web app which allows users to create the campaigns and manage them but with the security of the blockchain and the privacy of the user.",
    gitLink: "https://github.com/Pranshu321/Joinfund",
    liveLink: "http://joinfund.vercel.app/",
    listItems: ["Solidity", "Thirdweb", "ipfs", "React.js"],
  },
  {
    title: "Zapper",
    description:
      "This is a project, which will show the latest transactions,nfts of the user and user details on polygon or ethereum.",
    gitLink: "https://github.com/Pranshu321/zapper",
    liveLink: "https://zapper32.vercel.app/",
    listItems: ["Next.Js", "CSS", "Moralis"],
  },
  {
    title: "Signal (App Dev)",
    description:
      "This project aims to be a strong foundation for react-native applications. It provides a clear and organized structure, for each user to communicate via chat.",
    gitLink: "https://github.com/Pranshu321/health-pilot",
    liveLink:
      "https://expo.dev/@pranshu32/signal?serviceType=classic&distribution=expo-go",
    listItems: [
      "React Native",
      "CSS",
      "react-native-testing-library",
      "react-navigation",
    ],
  },
  {
    title: "News App (App Dev)",
    description:
      "App which provides the news as per the sources and the user's choice.",
    gitLink: "https://github.com/Pranshu321/Upfeed",
    liveLink:
      "https://expo.dev/@pranshu32/Upfeed?serviceType=classic&distribution=expo-go",
    listItems: ["React Native", "react-native-tab-view", "CSS"],
  },
  {
    title: "Unicov (App Dev)",
    description:
      "App which converts the from one unit to another unit using the API.",
    gitLink: "https://github.com/Pranshu321/Unicon",
    liveLink:
      "https://expo.dev/@pranshu32/Unicon?serviceType=classic&distribution=exp",
    listItems: [
      "React Native",
      "react-native-tab-view",
      "CSS",
      "convert-units",
    ],
  },
  {
    title: "Uber clone (App Dev)",
    description: "App which is the UI clone of the Uber application",
    gitLink: "https://github.com/Pranshu321/Uber-App",
    liveLink:
      "https://expo.dev/@pranshu32/Uber?serviceType=classic&distribution=expo-go",
    listItems: ["React Native", "Tailwind CSS", "Redux", "Google Autocomplete"],
  },
  {
    title: "Invoice Generator (App Dev)",
    description:
      "Project which generate the Generate Invoice using the details from the user and allow then to share the invoice on social platforms.",
    gitLink: "https://github.com/Pranshu321/Invoice-Creater-App",
    liveLink:
      "https://expo.dev/@pranshu32/Inwise?serviceType=classic&distribution=expo-go",
    listItems: ["React Native", "CSS", "Pdf Converter", "ShareAsync"],
  },
  {
    title: "Todo App (App Dev)",
    description:
      "App which allows the user to create the todo list and add the todos to the list.",
    gitLink: "https://github.com/Pranshu321/react-native-todo",
    liveLink:
      "https://expo.dev/@pranshu32/RN-Todo?serviceType=classic&distribution=expo-go",
    listItems: ["React Native", "CSS"],
  },
  {
    title: "Weather App",
    description:
      "Web app which provides the weather information of the user's location city and user can see different places weather.",
    gitLink: "https://github.com/Pranshu321/React-Weather-App",
    liveLink: "https://pranshu321.github.io/React-Weather-App",
    listItems: ["React", "CSS", "weather api"],
  },
  {
    title: "Splash Page",
    description:
      "One page website for the user to see the splash page of their kind.",
    gitLink: "https://github.com/Pranshu321/Splash_Page",
    liveLink: "https://pranshu321.github.io/Splash_Page/",
    listItems: ["html", "Css", "Javascript"],
  },
];
